/**
 * 퀘스트 안내판 폰트(`GosanjaOTF`) 선행 로드.
 *
 * 🔴 왜 앱 시작 시점인가
 *   안내판(`MissionNoticeBoard`)은 **4초만** 떠 있고 CSS 가 `font-display: swap` 이다.
 *   스캔이 일어난 뒤에 폰트를 받기 시작하면 그 4초가 통째로 대체 폰트(Katuri)로 지나가고,
 *   자폭이 약 16% 좁아 **디자인과 다른 화면이 그대로 아이에게 나간다**(2026-08-05 실측:
 *   제목 폭 644 vs 디자인 773). 화면 진입까지 기다리지 않고 앱이 뜨는 즉시 받아 두면
 *   로그인·라우팅에 걸리는 시간만큼 미리 벌어, 실제 스캔 때는 준비가 끝나 있다.
 *
 * 🔴 이 파일과 `MissionNoticeBoard.css` 의 `@font-face` 는 **한 쌍**이다.
 *   여기 적힌 패밀리명이 CSS 선언과 다르면 `document.fonts.load` 는 **아무것도 받지 않고
 *   조용히 성공**한다(일치하는 face 0개) — 화면을 직접 보기 전엔 아무도 모른다.
 *   그래서 반환값으로 "실제로 받았는지"를 알리고, 이름 일치를 테스트가 고정한다.
 *
 * ⚠️ 트레이드오프: tools 는 퀘스트 태블릿만 쓰는 게 아니라 운영자 PC(쿠폰·여권 등)도 쓴다.
 *   그쪽에서도 9.7MB 를 한 번 받는다. 브라우저 캐시에 남아 재방문 시엔 다시 받지 않는다.
 */

/** 🔴 `MissionNoticeBoard.css` 의 `@font-face { font-family: ... }` 와 반드시 같아야 한다. */
export const NOTICE_FONT_FAMILY = 'GosanjaOTF';

/** CSS Font Loading API 지정자. 크기는 무엇이든 되지만 실제 사용 크기(제목 128px)를 쓴다. */
export const NOTICE_FONT_SPEC = `128px ${NOTICE_FONT_FAMILY}`;

/**
 * @returns {Promise<boolean>} 실제로 face 를 받았으면 true.
 *   reject 하지 않는다 — 대체 폰트로도 글자는 읽히므로 앱 기동을 막을 이유가 없다.
 */
export default function preloadNoticeFont() {
  if (typeof document === 'undefined' || !document.fonts || !document.fonts.load) {
    return Promise.resolve(false);
  }
  return Promise.all([
    document.fonts.load(NOTICE_FONT_SPEC),
    document.fonts.load('700 58px MissionNoticePretendard'),
  ]).then(
    (groups) => groups.every((faces) => Array.isArray(faces) && faces.length > 0),
    () => false,
  );
}
